import * as React from 'react';

function IrDoorsIcon({ color = '#545454', ...props }) {
	return (
		<svg width={18} height={18} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M9.4599 12H18.5262M9.43989 7.29676L9.4499 6.13435M7.47412 2H11.1862C12.2907 2 13.1862 2.89543 13.1862 4V9.17132V14.9229V20C13.1862 21.1046 12.2907 22 11.1862 22H7.47412C6.36955 22 5.47412 21.1046 5.47412 20V4C5.47412 2.89543 6.36955 2 7.47412 2Z'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<rect x='15.3184' y='1.17188' width='7.80462' height='7.64024' rx='1.5' fill={color} />
			<path
				d='M17.6377 2.59006V7.17188H16.669V2.59006H17.6377ZM18.4347 7.17188V2.59006H20.2424C20.5884 2.59006 20.8837 2.65195 21.1283 2.77575C21.3744 2.89805 21.5616 3.0718 21.6899 3.29702C21.8196 3.52074 21.8845 3.78398 21.8845 4.08675C21.8845 4.39102 21.8189 4.65277 21.6876 4.87202C21.5564 5.08977 21.3662 5.25682 21.1172 5.37315C20.8696 5.48949 20.5698 5.54766 20.2178 5.54766H19.0075V4.7691H20.0612C20.2461 4.7691 20.3998 4.74375 20.5221 4.69304C20.6444 4.64233 20.7353 4.56626 20.795 4.46484C20.8561 4.36342 20.8867 4.23739 20.8867 4.08675C20.8867 3.93462 20.8561 3.80636 20.795 3.70195C20.7353 3.59755 20.6436 3.5185 20.5198 3.46481C20.3975 3.40962 20.2432 3.38203 20.0567 3.38203H19.4034V7.17188H18.4347ZM20.9091 5.08679L22.0478 7.17188H20.9784L19.8643 5.08679H20.9091Z'
				fill={color === 'white' ? '#545454' : 'white'}
			/>
		</svg>
	);
}

export default IrDoorsIcon;
